import LocalStorage from "redux-persist/lib/storage";
export default LocalStorage;
